<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false" >
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('班组名称')" prop="teamName">
                <a-input v-model="model.teamName" :placeholder="$t('请输入班组名称')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('班组介绍')" prop="teamIntroduce">
                <a-input v-model="model.teamIntroduce" :placeholder="$t('请输入班组介绍')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('组长名称')" prop="leaderId">
                <a-select show-search option-filter-prop="children" :placeholder="$t('请选择组长')" v-model="model.leaderId" allowClear>
                  <a-select-option :value="item.id" v-for="item in personnelList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('组长联系方式')" prop="leaderPhone">
                <a-input v-model="model.leaderPhone" :placeholder="$t('请输入组长联系方式')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('组员选择')" prop="inspectionTeamUserIds">
                <a-select mode="multiple" show-search option-filter-prop="children" :placeholder="$t('请选择组员')" v-model="model.inspectionTeamUserIds" allowClear @change="handleChange">
                  <a-select-option :value="item.userId" v-for="item in userList" :key="item.userId">{{item.userName}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('巡检区域')" prop="regionName">
                <a-input v-model="model.regionName" :placeholder="$t('请选择区域')" :readOnly="true" @click="setModalVisible()"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <a-modal v-model="modal2Visible" :title="title2" centered :width="800" :body-style="{ height: '500px', overflow: 'hidden', overflowY: 'scroll' }" :maskClosable="false">
        <template slot="footer">
            <a-button key="close" @click="handleCancel1">
            {{ $t('关闭') }}
            </a-button>
        </template>
        <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
        <a-spin tip="Loading..." :spinning="areaLoading">
            <el-tree
                class="filter-tree"
                :data="areaTree"
                :props="defaultProps"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :check-on-click-node="true"
                :check-strictly="checkStrictly"
                :highlight-current="true"
                node-key="id"
                :current-node-key="currentNodeKey"
                :default-expanded-keys="iExpandedKeys"
                @node-click="nodeClick"
                ref="areaTree">
                </el-tree>
        </a-spin>
    </a-modal>
  </j-modal>
</template>

<script>
  /* import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin'; */
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  export default {
    // mixins: [JeecgListMixin],
    mixins: [AreaChoosetMixin],
    name: 'deviceModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/engineering/inspectionTeam/add",
          edit: "/jeecg-engineering/engineering/inspectionTeam/edit",
          queryById: "/jeecg-engineering/engineering/inspectionTeam/queryById",
          userList: "/jeecg-engineering/inspection/inspectionUser/list",
          queryAreaTreeList: "/jeecg-engineering/inspection/inspectionArea/queryAreaTreeList",
        },
        personnelList: [],
        userList: [],
        modal2Visible: false,
        currSelected: {},
      }
    },
    computed: {
      title2() {
        return this.$t('请选择区域名称')
      },
      validatorRules() {
        return {
          leaderId: [{required:true,message:this.$t('请选择组长'),trigger:'change'}],
          teamName: [{required:true,message:this.$t('请输入班组名称'),trigger:'bulr'}],
          teamIntroduce: [{required:true,message:this.$t('请输入班组介绍'),trigger:'bulr'}],
          leaderPhone: [{required:true,message:this.$t('请输入组长联系方式'),trigger:'bulr'}],
          inspectionTeamUserIds: [{required:true,message:this.$t('请选择组员'),trigger:'change'}]
        }
      }
    },
    watch:{
      'model.leaderId':{
        handler(val){
          if(val){
            let that = this;
            let params = this.personnelList.find(per=>per.id == val);
            if(params){
              this.model.leaderName = params.name;
              this.model.leaderPhone = params.phone;
            }
            let index = -1
            index = this.model.inspectionTeamUserIds&&this.model.inspectionTeamUserIds.findIndex(u=>u==val)
            if(index==-1){
              if(this.model.inspectionTeamUserIds.length==1){
                // 替换
                this.model.inspectionTeamUserIds.splice(index,1,val);
              }else{
                this.model.inspectionTeamUserIds.push(val);
              }
            }
          }
        }
      }
    },
    created() {
      this.getPersonnelList();
    },
    methods: {
      getPersonnelList(){
        this.personnelList = [];
        this.userList = [];
        getAction(this.url.userList,{status:1,pageSize:999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.personnelList.push({
                id: item.userId,
                name: item.userName,
                phone: item.userPhone
              });
              this.userList.push({
                userId: item.userId,
                userName: item.userName,
                userPhone: item.userPhone,
              });
            });
          }
        });
      },
      add() {
        this.visible = true;
        this.model = {
          inspectionTeamUserIds: []
        };
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        });
        // this.getPersonnelList();
      },
      edit(record) {
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(record));
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        });
        // this.getPersonnelList();
        getAction(this.url.queryById,{id:this.model.id}).then(res=>{
          if(res.success){
            this.$set(this.model,'inspectionTeamUserIds',res.result.inspectionTeamUserIds);
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            that.model.inspectionTeamUserList = [];
            let list = that.userList&&that.userList.filter(p=>that.model.inspectionTeamUserIds.some(e=>e == p.userId));
            that.model.inspectionTeamUserList = list;
            // that.model.inspectionTeamUserList.unshift({
            //   userId: that.model.leaderId,
            //   userName: that.model.leaderName,
            //   userPhone: that.model.leaderPhone
            // });
            let row = that.personnelList.find(per=>per.id == that.model.leaderId);
            if(row){
              that.model.leaderName = row.name;
              that.model.leaderPhone = row.phone;
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok',that.model.id?true:false);
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      handleChange(e){
        this.model.inspectionTeamUserList = [];
        let list = this.userList&&this.userList.filter(p=>e.some(e=>e == p.userId));
        this.model.inspectionTeamUserList = list;
        // this.model.inspectionTeamUserList.unshift({
        //   userId: this.model.leaderId,
        //   userName: this.model.leaderName,
        //   userPhone: this.model.leaderPhone
        // });
      },
      setModalVisible(){
        this.loadTree()
        this.modal2Visible = true;
      },
      handleCancel1(){
        this.modal2Visible = false;
        this.currSelected = {};
        this.queryParam = {}
      },
      loadTree(){
        this.areaLoading = true
        var that = this
        that.areaTree = []
        getAction(this.url.queryAreaTreeList).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            // this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.areaTree.push(temp)
              that.setThisExpandedKeys(temp)
            }
            
          }
        }).finally(()=> {
          this.areaLoading = false
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
        }
      },
      nodeClick(record,node,data) {
        // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
          this.currentNodeKey = record.id
          this.$refs.areaTree.setCheckedKeys([record.id])
          //this.$refs.areaTree.setCurrentKey(record.id)
          this.currSelected = Object.assign({}, record);
          // 有的接口是areaId有的接口是userAreaId，兼容两个都写
          //  this.form.setFieldsValue({
          // 'userAreaName' : this.currSelected.areaName,
          // });
          // this.model.planArea = this.currSelected.areaName
          this.$set(this.model,'regionName',this.currSelected.areaName);
          this.$set(this.model,'regionId',this.currSelected.id);
          this.$refs.form.validateField('regionId');
          this.modal2Visible = false
      },
    }
  }
</script>